import React from 'react';
import { AlarmClockIcon } from 'lucide-react';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 w-full bg-tomato text-white" data-id="element-164" data-mp="3cvfurh72zwmw">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-3 px-4 py-2.5 text-center" data-id="element-165" data-mp="3ct3gbe0j84el">
        <AlarmClockIcon aria-hidden="true" className="hidden h-4 w-4 shrink-0 sm:block" data-id="element-166" data-mp="37xwfqf2k7ftw" />
        <p className="font-sans text-[13px] font-semibold leading-snug sm:text-sm" data-id="element-167" data-mp="32z2zievw1aq1">
          ¡CHAU ESTRÉS! Simplificá tu cocina y ahorrá hasta un 40% en el súper.{' '}
          <span className="font-normal text-white/85" data-id="element-168" data-mp="2u3wtbespgqmz">
            Oferta de lanzamiento válida por hoy.
          </span>
        </p>
      </div>
    </div>;
}